import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { CountDown } from '../starsStaking/CountDown.component';
import type { VotingDataProps } from './DashboardCarousel.component';
import styles from './VotingCarouselSlide.module.css';
export interface VotingCarouselSlideProps {
  currentSlide: number;
  votingData: VotingDataProps;
  countdownHeader: string;
}

export const VotingCarouselSlide: React.FC<VotingCarouselSlideProps> =
  props => {
    const [currentPNG, setCurrentPNG] = useState(1);
    const currentPNGRef = useRef(1);
    const history = useHistory();
    const goToVoting = () => {
      history.push('/platform/voting');
    };

    useEffect(() => {
      const myfunc = setInterval(function () {
        if (currentPNGRef.current === props.votingData.images.length - 1) {
          currentPNGRef.current = 1;
          setCurrentPNG(currentPNGRef.current);
        } else {
          currentPNGRef.current += 1;
          setCurrentPNG(currentPNGRef.current);
        }
      }, 3500);
      return () => {
        clearInterval(myfunc);
      };
    }, []);

    const dataImagesToShow = props.votingData.images.map((img, i) => {
      return (
        <img
          key={`${img}${i}`}
          src={img}
          className={styles.logoSquarify}
          alt=""
        />
      );
    });

    return (
      <div
        className={styles.carouselBanner + ' w-full'}
        style={
          3 === props.currentSlide ? { display: 'block' } : { display: 'none' }
        }
      >
        <div
          className="w-full h-full flex xl:justify-between justify-center flex-wrap-reverse box-border lg:p-8 lg:py-10 xl:py-12 p-6 relative rounded-lg"
          style={{
            background: '#000000',
          }}
        >
          <div
            className={
              'lg:w-7/12 xl:w-1/2 w-full flex flex-col lg:justify-between items-center lg:items-start box-border z-10 h-auto lg:text-left text-center'
            }
          >
            <div className="flex flex-col lg:gap-8">
              <div
                className={
                  styles.collectionName +
                  ' text-5xl lg:text-6xl xl:text-7xl mb-3 sm:mb-2 font-extrabold'
                }
              >
                MOVIE VOTING
              </div>

              <div className={'text-sm xl:text-base xl:pr-14 mb-8 font-bold'}>
                MOGUL holders can now vote the fair ability to influence and
                lend their voice to which projects will get made! A new way to
                finance and greenlight HollyWood movies.
                <br />
                <br />
                Discover the power of the first-ever consumer ready, blockchain
                voting system that uses quadratic votes.
              </div>
            </div>
            <div className="flex flex-col sm:flex-row w-full justify-start gap-6">
              <div
                aria-hidden
                className={
                  (!props.votingData.isVotingEnded
                    ? styles.voteButton
                    : styles.learnButton) +
                  ' w-full lg:w-5/6 h-10 lg:h-12 text-xs sm:text-sm	font-semibold	flex justify-center items-center cursor-pointer'
                }
                onClick={goToVoting}
              >
                {!props.votingData.isVotingEnded
                  ? 'Start Voting Now'
                  : 'View Round'}
              </div>
            </div>
          </div>

          <div className="md:w-5/12 xl:w-1/2 w-full z-10 flex flex-col mb-5 lg:mb-0 gap-2 lg:gap-5 justify-center items-center">
            <div
              className={
                'lg:w-2/3 md:w-full w-7/12 h-full flex items-center justify-center'
              }
            >
              {dataImagesToShow[currentPNG]}
            </div>
            <div className={styles.collectionName + ' text-4xl font-extrabold'}>
              {props.countdownHeader}
            </div>{' '}
            {props.countdownHeader !== 'VOTING ENDED' && (
              <div style={{ marginTop: '-7px' }}>
                <CountDown
                  voting
                  startDate={props.votingData.estimatedEndDate}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
